import { createDefaultContext } from "@imi/ui/helpers/createDefaultContext.js";
import { createContext, Dispatch, RefObject, SetStateAction } from "react";

type RouteDialogs = {
  setTrigger: Dispatch<
    SetStateAction<RefObject<HTMLAnchorElement | null> | null>
  >;
  trigger: RefObject<HTMLAnchorElement | null> | null;
};

export const RouteDialogsContext = createContext<RouteDialogs>(
  createDefaultContext(),
);
